import React, {ReactNode} from "react";
import {AnnotationProperties, SVG_NAMESPACE} from "../Annotation";
import FunctionHelper from "../../helper/FunctionHelper";
import PortalPureComponent from "../../components/PortalPureComponent";

export class GraphIcon extends PortalPureComponent<AnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		return (
			<svg xmlns={SVG_NAMESPACE} width={this.props.width} height={this.props.height} viewBox="0 0 32 32"
				 style={{
					 opacity: FunctionHelper.applyValue(this.props.opacity, 1),
					 transform: "rotate(" + FunctionHelper.applyValue(this.props.rotation, 0) + "deg)",
				 }}>
				<g transform="matrix(1.1428571,0,0,1.1428571,-2.2857143,-2.2857143)">
					<path
						d="M 30,30 H 22 V 8 h 8 z m -6,-2 h 4 V 10 h -4 z m -4,2 H 12 V 2 h 8 z m -6,-2 h 4 V 4 h -4 z m -4,2 H 2 V 14 h 8 z M 4,28 H 8 V 16 H 4 Z"
						style={{
							fill: "#000000"
						}}/>
				</g>
				<path
					d="m 2.3092784,22.854525 v -6.836197 h 2.2726231 2.2726231 v 6.836197 6.836197 H 4.5819015 2.3092784 Z"
					style={{
						fill: this.props.color,
						fillOpacity: 0.5
					}}/>
				<path
					d="M 13.745704,16 V 2.3092784 H 16 18.254296 V 16 29.690722 H 16 13.745704 Z"
					style={{
						fill: this.props.color,
						fillOpacity: 0.5
					}}/>
				<path
					d="M 25.145475,19.427262 V 9.163803 h 2.272624 2.272623 v 10.263459 10.26346 h -2.272623 -2.272624 z"
					style={{
						fill: this.props.color,
						fillOpacity: 0.5
					}}/>
			</svg>
		);
	}
}